import { Component, ElementRef, HostListener, SimpleChanges, ViewChild } from '@angular/core';
import { cloneDeep } from 'lodash';
import { Message, ConfirmationService, MessageService, TreeNode, ConfirmEventType, MenuItem } from 'primeng/api';
import { link, breadcrumb, stat } from '../admin/layout/header/header.component';
import { DataService } from '../services/data.service';
import { ExportService } from '../services/export.service';
import { GlobalConstants } from '../services/global-constants';
import { OrgUnitsService } from '../services/org-units.service';
import { PermissionHandlerService } from '../services/permission-handler.service';
import { TranslatorPipe } from '../services/translator.pipe';
import { DataView } from 'primeng/dataview';
import { Router } from '@angular/router';

@Component({
  selector: 'app-training-program',
  templateUrl: './training-program.component.html',
  styleUrl: './training-program.component.scss',
  providers: [ConfirmationService, MessageService],
})
export class TrainingProgramComponent {


  @ViewChild('scrollTarget') scrollTarget!: ElementRef;
  isScrolled: boolean = false;
  contentstats_data_types: any = null;
  contentstats_types: any = null;

  topValue: any = 10
  previousScrollPosition = 0
  @HostListener('window:scroll', ['$event'])
  onScroll(event: Event) {
    // Check the scroll position and set isScrolled accordingly
    // const scrollPosition = window.scrollY || document.documentElement.scrollTop;
    // if(this.showFilters){
    //   this.isScrolled = scrollPosition > 900; // Adjust the scroll threshold as needed


    // }
    // else  this.isScrolled = scrollPosition > 300;


    // const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;

    // if (currentScrollPosition > this.previousScrollPosition) {

    //   this.topValue = this.topValue + 7
    // } else if (currentScrollPosition < this.previousScrollPosition) {
    //   if(this.topValue > 10){
    //      this.topValue = this.topValue - 7
    //   }
    // }

    // this.previousScrollPosition = currentScrollPosition;



    // let topClass =  document.querySelector('#topClass'). 
    // topClass


  }

  translator: TranslatorPipe = new TranslatorPipe()
  messages: Message[] = [];
  skelition: boolean = true
  currentRoute: any;
  showFilters: boolean = true
  @ViewChild('dv')
  dataView!: DataView;

  header = this.translate('Content update logs')
  links: link[] = [];
  breadcrumbs: breadcrumb[] = [{ name: this.translate('Content update logs'), link: '/admin/data/update' }];
  stats: stat[] = [];

  apilink = GlobalConstants.apiURL;
  GlobalConstants = GlobalConstants;
  staticURL = GlobalConstants.staticFilesURL;
  reason: any = undefined

  data: any
  filteredData: any

  pages: any[] = [];
  showing: string = '';
  currentPage: number = 1;
  totalPages: number = 0;
  totalRecords: number = 0;
  currentTypeFilter: any = 'all';

  page: number = 1;
  rows: number = 10;
  first = 1
  sortOrder: number = 1;
  sortField: string = '';


  currentLogs: any

  //filter options
  ouTypes: any;

  selectedTreeData: any = []
  selectedTreeTags_current: any;
  selectedTreeData_orginal: any;
  types: any[] = [];
  selectedTreeTags: MenuItem[] = [];

  //Data Variables
  fieldTypes: any
  dataTypes: any

  rejectionModal = false

  parentOUS = [
    'الجهات المشاركة',
  ];

  //filter Variables
  LogsToshow: any
  statusOptions: any = [
    { name: 'PENDING', value: 1, arabic: this.translate('PENDING') },
    { name: 'PUBLISHED', value: 2, arabic: this.translate('PUBLISHED') },
    { name: 'COMPLETED', value: 3, arabic: this.translate('COMPLETED'), },
    // { name: 'REJECTED',value: 3, arabic: this.translate('REJECTED'), }
  ];
  typeOptions: any = [
    { name: 'ADD SERVICE', value: 1, arabic: this.translate('Add data'), },
    { name: 'EDIT', value: 2, arabic: this.translate('Release') },
    { name: 'OU CHANGE', value: 3, arabic: this.translate('Change classification') },
    { name: 'DELETE', value: 3, arabic: this.translate('Delete') },
  ];

  getStatusArabic(): string | undefined {
    const status = this.statusOptions.find((option: any) => option.name === this.logStatus);
    return status ? status.arabic : undefined;
  }


  //filters
  typeFilter: any = undefined;
  oufilter: any = undefined;
  logType: any = undefined
  logStatus: any = 'PENDING'
  logStatus_set: any = 'PENDING'
  searchText: any = undefined
  start_date: any = undefined
  end_date: any = undefined

  selectedViewId = undefined

  side_view: any = undefined
  downloadExcel: boolean = false

  contentUpdateUsers: any
  updatedBy: any
  approvedBy: any

  constructor(
    private dataService: DataService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private orgUnits: OrgUnitsService,
    private permissionService: PermissionHandlerService,
    private exportService: ExportService,
    private router: Router,
  ) { }

  ngOnInit() {



    Promise.all([
      this.fetchFieldType(), this.getDataType(), this.getTreeData(), this.fetchDataFields(), this.fetchUsers()
    ]).then(e => { this.getTrainingPrograms() });
  }

  hasPermission(unit: string, flag: string) {
    return this.permissionService.hasPermission(unit, flag);
  }


  getType(id: any) {
    return this.ouTypes.find((item: any) => item.value == id).label
  }



  closeProgramAddFrom(event: any) {
    if (event) {
      this.getTrainingPrograms()
    }
    this.addTrainingProgram = false
  }


  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }
  typeFilterLabel = null
  logTypeFilterLabel = null
  logStatusFilterLabel = "قيد الانتظار"

  //create query 
  generateQuery() {
    const queryRequest: any = {};

    // if (this.typeFilter !== null && this.typeFilter !== undefined) {
    //   this.typeFilterLabel = this.getType(this.typeFilter)
    //   queryRequest.data_type = this.typeFilter;
    // }

    if (this.oufilter !== null && this.oufilter !== undefined) {

      queryRequest.ous = this.oufilter._id;
    }

    // if (this.logType !== null && this.logType !== undefined) {
    //   this.logTypeFilterLabel = this.typeOptions?.find((item: any) => item.name == this.logType).arabic
    //   queryRequest.type = this.logType;
    // }

    if (this.logStatus !== null && this.logStatus !== undefined) {
      this.logStatusFilterLabel = this.statusOptions?.find((item: any) => item.name == this.logStatus).arabic
      queryRequest.status = this.logStatus;
    }

    if (this.searchText !== null && this.searchText !== undefined && this.searchText !== "") {
      queryRequest['$text'] = { $search: this.searchText };
    }

    if (this.start_date !== null && this.start_date !== undefined && (this.end_date == null || this.end_date == undefined)) {
      queryRequest.createdAt = this.start_date
    }

    if (this.end_date !== null && this.end_date !== undefined && (this.start_date == null || this.start_date == undefined)) {
      queryRequest.end_date = this.end_date

    }

    // if (this.end_date !== null && this.end_date !== undefined && this.start_date !== null && this.start_date !== undefined) {
    //   queryRequest.createdAt = {
    //     $gte: this.start_date,
    //     $lte: this.end_date
    //   }
    // }

    // if(this.updatedBy !== null && this.updatedBy !== undefined ){
    //   queryRequest.updated_by = this.updatedBy._id
    // }

    // if(this.approvedBy !== null && this.approvedBy !== undefined ){
    //   queryRequest.approved_by = this.approvedBy._id
    // }

    return queryRequest
  }

  updateHolder: any = undefined

  updateTrainingProgram(program: any) {
    this.updateHolder = program
    this.addTrainingProgram = true
  }

  async getTrainingPrograms() {
    try {
      this.logStatus_set = this.logStatus;
      this.skelition = true;
      this.showFilters = true
      this.side_view = undefined



      let query = this.generateQuery();

      // to give permissions of all ous

      // if(!query.ous){
      //   let newOuArray  = this.flattenTree(this.selectedTreeData)
      //   query.ous =  newOuArray 
      // }

      let res = await this.dataService.postData(`training-program/get-aggrigated?size=${this.rows}&page=${this.page}`, query)

      console.log("RESOURCE", res);
      if (res.error) {
        return
      }
      this.data = res.data.data.data



      console.log("==> isedited ", this.data)


      this.filteredData = this.data;
      this.totalRecords = res.data.data.totalRecords


      // this.contentstats_data_types = res.data[0].data_type;
      // this.contentstats_types = res.data[0].stats_type
      this.page = 1;
      this.rows = 10;
      this.skelition = false
    } catch (error) {
      console.log(error)
    }
  }

  //fetch content update users
  private async fetchUsers(): Promise<void> {
    let res = await this.dataService.getData('content-update/users');

    if (res.error) {
      return;
    }

    this.contentUpdateUsers = res.data[0];
    this.contentUpdateUsers.approved_by = this.contentUpdateUsers.approved_by.map((user: any) => {
      const fullName = `${user.name.first} ${user.name.middle} ${user.name.last}`;
      return { ...user, name: fullName };
    });
    this.contentUpdateUsers.updated_by = this.contentUpdateUsers.updated_by.map((user: any) => {
      const fullName = `${user.name.first} ${user.name.middle} ${user.name.last}`;
      return { ...user, name: fullName };
    });

    this.contentUpdateUsers

  }

  flattenTree(root: TreeNode[]): any[] {
    const result: any[] = [];
    root.map(e => this.flattenNode(e, result))
    // this.flattenNode(root, result);
    return result;
  }

  private flattenNode(node: TreeNode, result: any[]): void {
    result.push((node as any)?._id);
    if (node.children) {
      for (const child of node.children) {
        this.flattenNode(child, result);
      }
    }
  }




  // onScroll() {
  //   const container: any = document.querySelector('.scroll-container'); // Adjust this selector as needed.
  //   if (container.scrollTop + container.clientHeight >= container.scrollHeight) {
  //     // User has scrolled to the bottom, load more data.
  //     this.getTrainingPrograms();
  //   }
  // }

  openLog(data: any) {
    this.side_view = data
    this.selectedViewId = data._id
    if (data == undefined) return
    const element = this.scrollTarget?.nativeElement;
    element?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }


  getDataType = async () => {
    try {
      let res = await this.dataService.postData('data-type/get/', {
        active: true,
      });
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.ouTypes = res.data.map((item: any) => {
        return {
          label: item.arabic,
          value: item._id,
          icon: `pi pi-${item.icon}`,
        };
      });
    } catch (error) {
      console.log(error);
    }
  };

  private async fetchDataType(): Promise<void> {
    let res = await this.dataService.postData('data-type/get', {
      active: true,
    });
    console.log(res.data);
    if (res.error) {
      return;
    }

    this.dataTypes = res.data.map((item: any) => {
      return {
        _id: item._id,
        label: item.arabic,
        icon: `pi pi-${item.icon}`,
      };
    });
  }

  dataFields: any = []
  private async fetchDataFields(): Promise<void> {
    let res = await this.dataService.postData('data-fields/get', {
      active: true,
    });
    console.log(res.data);
    if (res.error) {
      return;
    }

    this.dataFields = res.data;
  }

  //Get filed types
  private async fetchFieldType(): Promise<void> {
    let res = await this.dataService.postData('field-type/get/', {
      active: true,
    });
    console.log(res.data);
    if (res.error) {
      return;
    }
    this.fieldTypes = res.data
  }

  refresh() {
    this.typeFilterLabel = null
    this.logTypeFilterLabel = null
    this.logStatusFilterLabel = "قيد الانتظار"
    this.typeFilter = undefined;
    this.oufilter = undefined;
    this.start_date = undefined;
    this.end_date = undefined
    this.filteredData = this.data;
    this.logType = undefined,
      this.updatedBy = undefined,
      this.approvedBy = undefined
    // this.logStatus = 'PENDING'
    this.side_view = undefined
    this.getTrainingPrograms()
  }

  // filterData(data: any, key: any, value: any) {
  //   let results: any = [];

  //   function recursiveFilter(obj: any, parentObj = null) {
  //     if (Array.isArray(obj)) {
  //       obj.forEach((item) => recursiveFilter(item, parentObj));
  //     } else if (typeof obj === 'object') {
  //       if (obj != null && obj.hasOwnProperty(key) && obj[key] === value) {
  //         if (parentObj) {
  //           results.push(parentObj);
  //         }
  //         results.push(obj);
  //       }
  //       if (obj != null && obj != undefined)
  //         Object.values(obj).forEach((value) => recursiveFilter(value, obj));
  //     }
  //   }

  //   recursiveFilter(data);
  //   return results;
  // }

  applyOUPermission(data: any) {
    let result: boolean = false;
    for (let ou of data.breadcrumbs) {
      if (ou._id) {
        result = this.orgUnits.childrenContainsId(this.selectedTreeData_orginal, ou._id);
      } else {
        result = this.orgUnits.childrenContains(this.selectedTreeData_orginal, ou.name);
      }
      if (result) {
        break;
      }
    }
    return result;
  }

  changeToNumber(arg0: string): number {
    return Number(arg0);
  }

  applyFilterGlobal($event: any, stringVal: any) {
    console.log('KEY CEHCK', this.data);
    console.log($event.target.value);
    this.dataView.filter($event.target.value, stringVal);
  }


  applyTypeFilter(value: any) {
    if (this.currentTypeFilter != value) {
      this.currentTypeFilter = value;
    } else {
      this.currentTypeFilter = 'all';
    }

    console.log(value);
    if (this.currentTypeFilter == 'all') {
      this.dataView.filter('', 'contains');
    } else {
      this.dataView.filter(value, 'equals');
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['searchVal']) {
      const currentValue = changes['searchVal'].currentValue;
      console.log('CURRENT', currentValue);
      this.dataView.filter(currentValue, 'contains');
    }
  }

  onPageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
    this.page = event.page + 1
    this.getTrainingPrograms()
  }

  moveToLast(reverse: boolean) {
    if (reverse) {
      this.page = 0;
      this.rows = this.dataView.rows;
      this.currentPage = 1;
      this.dataView.paginate({ page: this.page, rows: this.rows })
    } else {
      const maxPage = Math.ceil(this.totalRecords / this.dataView.rows);
      this.page = (maxPage - 1) * this.dataView.rows;
      this.rows = this.dataView.rows;
      this.currentPage = maxPage;
      this.dataView.paginate({
        page: this.page,
        rows: this.rows
      });
    }
  }

  getFieldName(type: any) {
    return this.fieldTypes.find((item: any) => item._id == type).name
  }

  getFieldIcon(type: any) {
    return this.fieldTypes.find((item: any) => item._id == type).icon
  }

  getDataTypeIcon(id: any) {
    return this.dataTypes.find((item: any) => { return item._id == id }).icon
  }

  getDataTypeName(id: any) {
    return this.dataTypes.find((item: any) => { return item._id == id }).label
  }

  getDataTypeNameByDataFields(id: string) {
    return this.dataFields.find((item: any) => { return item._id == id }).type.name
  }


  //Get type of the filed
  getFieldType(type: any) {
    if (type._id) {
      type = type._id
    }
    if (this.fieldTypes == undefined) {
      this.fetchFieldType().then(() => {
        var result = this.fieldTypes.find((item: any) => item._id == type)?.name;
        return result;
      })
    } else {
      var result = this.fieldTypes.find((item: any) => item._id == type)?.name
      return result;
    }
  }

  //Approve log
  confirmApprove(logData: any) {
    let log: any = {
      _id: logData._id,
      status: 'PUBLISHED',
      courses: logData?.courses.map((e: any) => e.trainingId?._id)
    }
    this.confirm({
      message: this.translate('Are you sure you want to do this?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: () => this.ApproveLog(log),
    });
  }

  confirmReject() {
    this.rejectionModal = true;
  }

  //API Call Reject
  async RejectLog(logData: any) {
    try {

      if (!this.reason) return
      let log: any = {
        _id: logData._id,
        type: logData.type,
        before: logData.before,
        after: logData.after,
        status: 'REJECTED',
        reject_reason: this.reason
      }

      if (logData.type != 'ADD SERVICE') log.service_id = logData?.service_id

      let res = await this.dataService.postData('content-update/reject', log, 'PUT', false);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return
      }

      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];

      window.location.reload();
      this.reason = undefined;
      this.rejectionModal = false

      //Updating logs from front
      this.currentLogs.forEach((log: any) => {
        if (log._id === logData._id) {
          log.status = 'REJECTED';
        }
      });

      this.LogsToshow = this.LogsToshow.filter((log: any) => { return log._id !== logData._id });
      await this.getTrainingPrograms()
      // this.filterFunction()
    } catch (error) {
      console.log(error)
    }
  }

  //API Call Approve
  async ApproveLog(logData: any) {
    try {



      let res = await this.dataService.postData('training-program/', logData, 'PUT', false);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];


      window.location.reload()

    } catch (error) {
      console.log(error)
    }
  }

  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false;
    }
  }

  currentview: any = {
    id: 0,
    name: 'لا توجد بيانات',
    breadcrumbs: [],
  };

  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: 'نعم',
      rejectLabel: 'لا',
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }

  sortBreadcrums(data: any) {
    return data.sort((a: any, b: any) => {
      return b.depth - a.depth;
    });
  }

  modalVisibilities: boolean[] = [];
  // Function to toggle modal visibility for a specific item.
  toggleModal(index: number) {
    this.modalVisibilities[index] = !this.modalVisibilities[index];
  }

  //service grt
  changeCurrentDataItem(dataItem: any, field: any, index: number) {
    field.data = dataItem
    this.toggleModal(index)
  }


  //Get tree data and as per the  permission
  async getTreeData() {
    this.selectedTreeData_orginal = await this.permissionService.extractOUChildren('TRAINING_PROGRAM', 'r');
    this.filterTreeByTag(['Ministries/Entities', 'Organisational Units', 'Branches', 'Organisational Structure']);
  }

  filterTreeByTag(tag: string[]) {
    // Create a deep copy of the selected data using lodash.clonedeep
    this.selectedTreeData = cloneDeep(this.selectedTreeData_orginal);
    this.selectedTreeData = this.selectedTreeData
      .map((node: any) => this.filterNodes(node, tag))
      .filter((filteredNode: any) => filteredNode !== null);
    console.log(this.selectedTreeData);

    if (this.selectedTreeData.length == 0) {
      let cloneitems: any = []
      this.selectedTreeData_orginal.forEach((item: any) => {
        cloneitems.push({
          data: item.data,
          id: item.id,
          label: item.label,
          parent: item.parent,
          tag: item.tag,
          _id: item._id,
          children: []
        })
      });
      this.selectedTreeData = cloneDeep(cloneitems);
    }
  }

  filterNodes(node: any, tag: string[]): any | null {
    // Recursively filter children nodes

    if (node.children && node.children.length > 0) {
      node.children = node.children
        .map((childNode: any) => this.filterNodes(childNode, tag))
        .filter((filteredChild: any) => filteredChild !== null);
    }

    // Include the current node if it matches the tag or any of its children do
    if (tag.includes(node.tag) || (node.children && node.children.length > 0)) {
      return node;
    }

    return null; // Exclude this node from the result
  }




  // public async cleanDataForContentUpdate(data: Array<any>): Promise<any> {

  //   await this.getExportContentUpdates()

  //   let cleanedData: Array<any> = [];

  //   this.exportData.forEach((obj: any) => {

  //     let breakcrums = ''
  //     for(let i of this.sortBreadcrums(obj.before.dataview?.breadcrumbs)){
  //       if(breakcrums == ''){
  //         breakcrums = i.label
  //       } else  breakcrums = breakcrums + ' > ' + i.label
  //     }

  //     let newObj: any = {
  //       'التاريخ' : obj?.createdAt?.substring(0,10),
  //       'طلب من قبل' : obj.updated_by.name.first + obj.updated_by.name.middle + obj.updated_by?.name?.last,
  //       'الوحدة التنظيمية' : breakcrums,
  //       'الحالة' : this.translate(obj.status),
  //       'الخدمات' : obj?.before?.dataview.type?.arabic,
  //       'النوع' : this.translate(obj.type),
  //       'اسم البيانات' : obj?.before?.name ,


  //     };

  //     if(obj.status == 'APPROVED'){
  //       newObj['الموافقة من قبل'] = obj.approved_by.name.first + obj.approved_by.name.middle + obj.approved_by?.name?.last
  //       newObj['تاريخ الموافقة'] = obj?.updatedAt?.substring(0,10)


  //     }

  //     if(obj.status == 'APPROVED'){
  //       newObj['الرفض من قبل'] = obj.approved_by.name.first + obj.approved_by.name.middle + obj.approved_by?.name?.last
  //       newObj['تاريخ الرفض'] = obj?.updatedAt?.substring(0,10)

  //     }

  //     cleanedData.push(newObj);
  //   });
  //   return cleanedData;
  // }




  protected confirmUndoDelete(log: any) {

    this.confirm({
      message: this.translate('Are you sure you want to do this?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: () => this.undoDelete(log),
    });
  }

  private async undoDelete(log: any) {
    try {

      let data: any = {
        _id: log._id,
        service_id: log.service_id
      }

      let res = await this.dataService.postData('content-update/undo-delete', data, 'PUT', false)

      if (res.error) return

      this.cleanOu(log.ous)

      await this.getTrainingPrograms()

    } catch (error) {
      console.log(error)
    }
  }

  async cleanOu(ous: any) {
    try {
      let res = await this.dataService.postData('data/ou-clean', ous)
      if (res.error) return false
      return true
    } catch (error) {
      return error
    }
  }



  //new Variables
  addTrainingProgram: boolean = false

  navigateToTrainingPage(trainingId: string, params: any) {
    const url = this.router.createUrlTree(['/training/training-page', trainingId], { queryParams: params }).toString();
    window.open(url);
  }

  openCourse(course: any, flag: string) {
    course ? this.navigateToTrainingPage(course, { from: 'SBC' }) : null
  }



}
